// A chave do Mentor do Livro no app (20/10/2026): o servidor diz em
// /api/recursos se a trilha está ligada (MENTOR_LIVRO_ATIVO,
// server/mentor-livro). Mesmo esquema do circulo/chave.ts: enquanto não
// responde, ou se falhar, vale DESLIGADO — nada da trilha aparece, nem pisca.

import { recursos } from '../recursos';

let valor: boolean | null = null;

const promessa: Promise<boolean> = recursos.then((j) => (valor = j.mentorLivro === true));

/** O que já se sabe: true, false ou null (ainda perguntando). */
export const mentorLivroAtivoAgora = (): boolean | null => valor;

/** A resposta do servidor (uma vez por carregamento). */
export const mentorLivroAtivo = (): Promise<boolean> => promessa;
